import { render, staticRenderFns } from "./CQuill.vue?vue&type=template&id=685975b3&"
import script from "./CQuill.vue?vue&type=script&lang=js&"
export * from "./CQuill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports